import { render, staticRenderFns } from "./UncollectedList.vue?vue&type=template&id=76efc7ae&scoped=true"
import script from "./UncollectedList.vue?vue&type=script&lang=js"
export * from "./UncollectedList.vue?vue&type=script&lang=js"
import style0 from "./UncollectedList.vue?vue&type=style&index=0&id=76efc7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76efc7ae",
  null
  
)

export default component.exports